import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import './assets/globals.css'

Vue.config.productionTip = false

// Similar ao web/: expõe axios no prototype
Vue.prototype.$axios = axios

// Chart.js 2 + plugin de labels (para aproximar o visual do Recharts com labels nas barras)
Chart.plugins.register(ChartDataLabels)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

